import Loader from "../components/Loader";

export default function Loading() {
    return (
        <div className="vh-100 d-flex justify-content-center align-items-center">
            <Loader />
        </div>
    );
}
